export var CELL_TYPE;
(function (CELL_TYPE) {
    CELL_TYPE[CELL_TYPE["NUMERIC"] = 0] = "NUMERIC";
    CELL_TYPE[CELL_TYPE["DATE"] = 1] = "DATE";
    CELL_TYPE[CELL_TYPE["DATE_TIME"] = 2] = "DATE_TIME";
    CELL_TYPE[CELL_TYPE["TEXT"] = 3] = "TEXT";
    CELL_TYPE[CELL_TYPE["ID"] = 4] = "ID";
})(CELL_TYPE || (CELL_TYPE = {}));
